import { useTheme, useMediaQuery } from '@mui/material';

const useResponsive = () => {
    const theme = useTheme();
    const isDesktopScreen = useMediaQuery('(min-width:1200px)');
    const isTabletScreen = useMediaQuery('(min-width:600px) and (max-width:1199px)');
    const isMobileScreen = useMediaQuery('(max-width:599px)');

    return { isDesktopScreen, isTabletScreen, isMobileScreen };
};

export default useResponsive;